import React, { CSSProperties } from 'react'

interface IconProps {
  value: string
  color?: string
  style?: CSSProperties
}

export const Icon: React.FC<IconProps> = ({ value, style }) => (
  <i style={{ ...style }} className={`material-icons `}>
    {value}
  </i>
)
